export default "__VITE_ASSET__Bea9iXO5__"